import CustomSwiper from "@/components/Swiper/CustomSwiper";
import CustomSwiperSlide from "@/components/Swiper/CustomSwiperSlide";

export default function AboutPageMarketSlider({ data, reverseDirection }) {
  return (
    <CustomSwiper
      view={{ desktop: 2.7, laptop: 2.3, md: 1.5, mobile: 1.3 }}
      space={48}
      reverseDirection={reverseDirection}
    >
      {[...data, ...data, ...data].map(({ title, image }, idx) => (
        <CustomSwiperSlide key={idx}>
          <div>
            <img
              src={image}
              alt=""
              className="w-[100%] h-[264px] object-cover"
            />
          </div>
        </CustomSwiperSlide>
      ))}
    </CustomSwiper>
  );
}
